<script setup>
import { addThousandsSeparator } from '~/utils/utils.js';
import Card from '~/components/Card.vue';
import CardLabel from '~/components/CardLabel.vue';
import InfoTooltip from '~/components/InfoTooltip.vue';
import LoadingSkeleton from '~/components/LoadingSkeleton.vue';

// Props
const props = defineProps({
    currencies: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
});

// Currencies data
const currencyData = [
    { code: 'usd', name: 'US Dollar', flag: '/images/flags/us.svg' },
    { code: 'eur', name: 'Euro', flag: '/images/flags/eu.svg' },
    { code: 'gbp', name: 'British Pound', flag: '/images/flags/gb.svg' },
    { code: 'jpy', name: 'Japanese Yen', flag: '/images/flags/jp.svg' },
    { code: 'aud', name: 'Australian Dollar', flag: '/images/flags/au.svg' },
    { code: 'cad', name: 'Canadian Dollar', flag: '/images/flags/ca.svg' },
    { code: 'chf', name: 'Swiss Franc', flag: '/images/flags/ch.svg' },
    { code: 'cny', name: 'Chinese Yuan', flag: '/images/flags/cn.svg' },
    { code: 'krw', name: 'South Korean Won', flag: '/images/flags/kr.svg' },
    { code: 'sgd', name: 'Singapore Dollar', flag: '/images/flags/sg.svg' }
];
</script>

<template>
    <Card>
        <div class="flex flex-col space-y-6">
            <!-- Card Label -->
            <div class="flex items-center">
                <CardLabel text="Global Currencies" />
                <InfoTooltip text="Kaspa price in different currencies" />
            </div>
            
            <!-- Currencies Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
                <!-- Currency Card -->
                <div v-for="currency in currencyData" :key="currency.code" class="group relative rounded-2xl bg-gray-50 dark:bg-gray-700/50 overflow-hidden">
                    <div class="relative z-10 flex items-center p-4">
                        <div class="flag-wrapper mr-4">
                            <NuxtImg :src="currency.flag" :alt="`${currency.code.toUpperCase()} flag`" height="30" width="40" loading="lazy" class="rounded-lg shadow-md dark:shadow-none" />
                        </div>
                        <div class="flex flex-col flex-1">
                            <span class="text-sm font-medium text-gray-600 dark:text-gray-400">
                                {{ currency.name }}
                            </span>

                            <!-- Currency Value -->
                            <LoadingSkeleton v-if="props.loading" height="28px" width="100px" />
                            <div v-else class="font-semibold text-lg slide-in-up">
                                <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#70C7BA] to-[#4A8D83]">
                                    {{ addThousandsSeparator(props.currencies[currency.code] || 0, 4) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>